/**
 * @file 菜单
 * @author  fangsimin
 * @date    2019-01-02 10:55:08
 * @last Modified by    fangsimin
 * @last Modified time  2020-02-09 21:11:36
 */
<template>
    <el-menu v-if="data && data.length"
        :default-active="activeIndex"
        :mode="mode"
        :collapse="isCollapse"
        :router="true"
        class="el-menu-demo" @select="handleSelect">
        <template v-for="item in data">
            <menu-item v-if="item && item['key']"
                :key="item['key']"
                :routekey="'/' + (base ? base + '/' : '') + item['key']"
                :data="item"></menu-item>
        </template>
    </el-menu>
</template>

<script>

import MenuItem from './MenuItem';

export default {
    props: {
        mode: 'vertical', // 模式：horizontal / vertical
        isCollapse: true, // 是否是合起状态，合起模式只显示icon
        data: {
            type: Array,
            default: () => []
        },
        base: ''
    },
    data() {
        return {
            activeIndex: '' // 当前激活的menu
        };
    },
    watch: {
        '$route.path': {
            handler(val) {
                this.activeIndex = val;
            },
            immediate: true
        }
    },
    methods: {
        handleSelect(key, keyPath) {
            // console.log(key, keyPath);
        }
    },
    components: {
        MenuItem
    }
};
</script>
<style lang="scss">
    $bg-active-color: #1C2950;
    $font-active-color: #4583FF;
    @mixin menu-style {
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        font-weight: 700;
        font-size: 14px;
        color: rgba($color: #fff, $alpha: 0.50);
    }
    @mixin collapse-menu-style {
        width: 20px;
        height: 20px;
        vertical-align: middle;
    }
    .el-menu-demo {
        border-right: none;
        &.el-menu, .el-submenu >.el-menu {
            background-color: #293965;
        }
        &.el-menu > .menu-items {
            &:focus {
                outline: none;
            }
            &>.el-menu-item {
                @include menu-style();
                & > .menu-icon {
                    vertical-align: middle;
                    width: 15px;
                    height: 15px;
                    margin-left: 7px;
                    margin-right: 7px;
                }
                & > span {
                    opacity: 0.5;
                    color: #fff;
                }
                &:hover, &:focus {
                    // background-color: rgba($color: #fff, $alpha: 0.15);
                    background-color: $bg-active-color;
                }
                &.is-active {
                    background-color: $bg-active-color;
                    i, span {
                        opacity: 1;
                        color: $font-active-color;
                    }
                }
                &.is-active::before {
                    display: block;
                    position: absolute;
                    left: 0;
                    top: 0;
                    bottom: 0;
                    content: "";
                    width: 5px;
                    // background-color: #fff;
                    background-color: $font-active-color;
                }
            }
        }
        &.el-menu > .menu-items .el-submenu {
            .el-submenu__title {
                @include menu-style();
                height: 60px;
                line-height: 60px;
                & > .menu-icon {
                    vertical-align: middle;
                    width: 15px;
                    height: 15px;
                    margin-left: 7px;
                    margin-right: 7px;
                }
                span {
                    opacity: 0.5;
                    color: #fff;
                }
                &:focus, &:hover {
                    // background-color: rgba($color: #fff, $alpha: 0.15);
                    background-color: $bg-active-color;
                }
            }
            &.is-active {
                & > .el-submenu__title {
                    // background-color: rgba($color: #fff, $alpha: 0.15);
                    background-color: $bg-active-color;
                    & > span {
                        color: $font-active-color;
                        opacity: 1;
                    }
                    &::before {
                        display: block;
                        position: absolute;
                        left: 0;
                        top: 0;
                        bottom: 0;
                        content: "";
                        width: 5px;
                        // background-color: #fff;
                        background-color: $font-active-color;
                    }
                }
            }
        }
        .el-submenu .menu-items {
            &>.el-menu-item {
                @include menu-style();
                min-width: auto;
                span {
                    opacity: 0.5;
                    color: #fff;
                    padding-left: 12px;
                }
                &:hover, &:focus {
                    // background-color: rgba($color: #fff, $alpha: 0.15);
                    background-color: $bg-active-color;
                }
                &.is-active {
                    background: none;
                    & > .el-submenu__title > span {
                        color: $font-active-color;
                    }
                    i, span {
                        color: $font-active-color;
                        opacity: 1;
                    }
                }
            }
        }
        .el-submenu__icon-arrow {
            color: #fff;
            font-weight: bold;
        }
        &.el-menu > .menu-items > .el-menu-item > span,
        &.el-menu > .menu-items > .el-submenu > .el-submenu__title > span {
            color: #fff;
            opacity: 1;
        }
        &.el-menu > .menu-items > .el-submenu > .el-menu > .menu-items > .el-submenu {
            & > .el-submenu__title {
                height: 40px;
                line-height: 40px;
                background-color: #293965;
                &::before {
                    display: none;
                }
                .menu-icon {
                    display: none;
                }
                i {
                    opacity: 0.5;
                }
                span {
                    padding-left: 12px;
                    color: rgba(255, 255, 255, 0.5);
                }
            }
            .el-menu-item {
                height: 35px;
                line-height: 35px;
                font-size: 12px;
                span {
                    padding-left: 7px;
                }
            }
        }
    }
    .el-menu--collapse {
        &.el-menu > .menu-items > .el-menu-item {
            height: 60px;
            line-height: 60px;
            .menu-icon {
                @include collapse-menu-style();
                margin: 0;
            }
        }
        &.el-menu > .menu-items > .el-submenu {
            & > .el-submenu__title {
                .menu-icon {
                    @include collapse-menu-style();
                    margin: 0;
                }
                & > span {
                    display: none;
                    width: 0;
                    height: 0;
                }
                & > .el-submenu__icon-arrow {
                    display: none;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Menu/index.vue